(function () {
  'use strict';

  /* ── 产品页各板块入场动画（Intersection Observer） ─────────
     目标：主区域之后的所有板块，滚动进入视口时触发 fade-up 动画
  ─────────────────────────────────────────────────────────── */

  /* 产品页板块的 section key（来自 templates/product.json） */
  var SELECTORS = [
    '[id*="__kompac_video_carousel_yXCtQJ"]',
    '[id*="__section_PLdfc3"]',
    '[id*="__kompac_product_features_pf001"]',
    '[id*="__section_yteGXh"]',
    '[id*="__kompac_product_comparison_JJdBxr"]',
    '[id*="__section_XH8WaH"]',
    '[id*="__17733932614407e28b"]'
  ].join(', ');

  function init() {
    var sections = document.querySelectorAll(SELECTORS);
    if (!sections.length) return;

    /* 初始状态：隐藏 + 向下偏移 */
    sections.forEach(function (el) {
      el.classList.add('kp-fade-up');
    });

    /* 信任横幅内的每个 badge 单独延迟出现 */
    var badgeSection = document.querySelector('[id*="__section_XH8WaH"]');
    if (badgeSection) {
      var badges = badgeSection.querySelectorAll('.kp-trust-badge');
      badges.forEach(function (badge, i) {
        badge.setAttribute('data-delay', i + 1);
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kp-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    sections.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
